var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-3427 -736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 120,
    height: 120,
    rx: 15,
    transform: "translate(3427 736)",
    fill: "#eee8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(3447 756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M291.448,10H269.7a1.176,1.176,0,0,0-1.175,1.175V17.2a4.7,4.7,0,0,0,0,9.106v8.965a1.176,1.176,0,0,0,1.175,1.175h9.991a1.176,1.176,0,0,0,1.175-1.175,2.351,2.351,0,1,1,4.7,0,1.176,1.176,0,0,0,1.175,1.175H293.8a1.175,1.175,0,0,0,1.175-1.175V13.526A3.53,3.53,0,0,0,291.448,10Zm1.175,24.1h-4.851a4.7,4.7,0,0,0-9.106,0h-7.789V25.281a1.176,1.176,0,0,0-1.175-1.175,2.351,2.351,0,1,1,0-4.7,1.176,1.176,0,0,0,1.175-1.175V12.351h20.571a1.177,1.177,0,0,1,1.175,1.175Z",
    transform: "translate(-234.974 -10)",
    fill: "#5b2fda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M59.369,114.1H53.343a4.7,4.7,0,0,0-9.106,0H36.448v-8.816a1.175,1.175,0,0,0-1.175-1.175,2.351,2.351,0,1,1,0-4.7,1.175,1.175,0,0,0,1.175-1.175V91.175A1.176,1.176,0,0,0,35.272,90H27.926a1.175,1.175,0,0,0,0,2.351H34.1V97.2a4.7,4.7,0,0,0,0,9.106V114.1H25.281a1.176,1.176,0,0,0-1.175,1.175,2.351,2.351,0,1,1-4.7,0,1.176,1.176,0,0,0-1.175-1.175H12.351V93.526a1.177,1.177,0,0,1,1.175-1.175h5a1.175,1.175,0,0,0,0-2.351h-5A3.53,3.53,0,0,0,10,93.526v43.492a3.53,3.53,0,0,0,3.526,3.526H57.018a3.53,3.53,0,0,0,3.526-3.526V115.272A1.176,1.176,0,0,0,59.369,114.1ZM34.1,132.317v5.877H13.526a1.177,1.177,0,0,1-1.175-1.175V116.448H17.2a4.7,4.7,0,0,0,9.106,0H34.1v8.816a1.176,1.176,0,0,0,1.175,1.175,2.351,2.351,0,0,1,0,4.7A1.176,1.176,0,0,0,34.1,132.317Zm24.1,4.7a1.177,1.177,0,0,1-1.175,1.175H36.448v-4.851a4.7,4.7,0,0,0,0-9.106v-7.789h8.816a1.176,1.176,0,0,0,1.175-1.175,2.351,2.351,0,1,1,4.7,0,1.176,1.176,0,0,0,1.175,1.175h5.877Z",
    transform: "translate(-10 -80.545)",
    fill: "#5b2fda"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.175,
    cy: 1.175,
    r: 1.175,
    transform: "translate(12.059 9.404)",
    fill: "#5b2fda"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/Blueprint.da28e0c328e786f06e373df361d1f375.svg";
export { ForwardRef as ReactComponent };